import type { Status } from './Alert'

export const alertStyles = (status: Status) => {
  if (status.sucess) {
    if (status.info) {
      return {
        containerBackground: 'var(--color-main-faded)',
        textColor: 'var(--color-main-dark)',
        iconColor: 'var(--color-main)',
      }
    }

    return {
      containerBackground: 'var(--color-positiveFeedback-faded)',
      textColor: 'var(--color-positiveFeedback-dark)',
      iconColor: 'var(--color-positiveFeedback-dark)',
    }
  }

  return {
    containerBackground: 'var(--color-positiveFeedback-faded)',
    textColor: 'var(--color-negativeFeedback-dark)',
    iconColor: 'var(--color-negativeFeedback-dark)',
  }
}
